import type { DocumentUpload } from '@onefootprint/request-types/dashboard';

export const getUploadKey = (upload: DocumentUpload | (DocumentUpload & { isLatest: boolean })) => {
  return `${upload.identifier}:${upload.version}`;
};

export const getUploadIdentifierFromKey = (key: string) => {
  return key.split(':')[0];
};
